import React, { useEffect } from "react";
import { Form, Layout } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import Spacer from "../../../components/layouts/Spacer";
import FloatingFormActions from "../../../components/forms/FloatingFormActions";
import {
  setChangedFormItems,
  commitChanges,
  resetSettings,
  fetchSettings,
} from "../houseVisitsSlice";
import { getFullName } from "../../../components/util/helpers";
import SettingsForm from "./SettingsForm";
import { getChangedItems } from "../../../components/util/helpers";
import RestrictedContext from "../../../components/util/RestrictedContext";
import { usePermission } from "../../../hooks/accessControl";
import { useParams } from "react-router-dom";
import SettingsWrapper from "./Settings.style";
import SettingsHeader from "./SettingsHeader";
var flatten = require("flat");

const Settings = (props) => {
  const { hide } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  const dispatch = useDispatch();

  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const settings = useSelector(
    (state) => state.houseVisits.settings.activeRecord
  );

  const default_months_between = useSelector(
    (state) => state.organization.details.months_between_house_visits
  );

  const changedItems = useSelector(
    (state) => state.houseVisits.settings.changedItems.changed
  );

  const changedValues = useSelector(
    (state) => state.houseVisits.settings.changedItems.values
  );

  const saveLoading = useSelector(
    (state) => state.pendingActions["houseVisits/updateSettings"]
  );

  useEffect(() => {
    dispatch(fetchSettings({ patientId: activePatient.id }));
    return () => {
      dispatch(resetSettings());
    };
  }, [activePatient.id, dispatch]);

  useEffect(() => {
    const proffesionalEmployeeName = settings.professional_employee_id
      ? `${getFullName(
          settings.professional_employee.surename,
          settings.professional_employee.first_name
        ).concat(
          ", ",
          intl.formatMessage({
            id: `app.dataSelect.professional_role_id.${settings.professional_employee.professional_role_id}`,
          })
        )}`
      : null;
    const controllerEmployeeName = settings.controller_employee_id
      ? `${getFullName(
          settings.controller_employee.surename,
          settings.controller_employee.first_name
        ).concat(
          ", ",
          intl.formatMessage({
            id: `app.dataSelect.professional_role_id.${settings.controller_employee.professional_role_id}`,
          })
        )}`
      : null;

    const updated = {
      ...settings,
      organization_default: !settings["months_between_visits"],
      active: settings["id"] === 0 ? true : settings["active"],
    };
    dispatch(
      setChangedFormItems({
        changed:
          settings["id"] === 0
            ? ["organization_default", "active"]
            : ["organization_default"],
        values: {
          ...settings,
          organization_default: !settings["months_between_visits"],
          active: settings["id"] === 0 ? true : settings["active"], //set default to true on the first time
        },
      })
    );
    const values = flatten(updated || {}, {
      safe: true,
    });
    form.setFieldsValue({
      ...values,
      professional_employee_id: proffesionalEmployeeName,
      controller_employee_id: controllerEmployeeName,
    });
  }, [form, settings, default_months_between, dispatch]);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const onFinish = async () => {
    const action = await dispatch(commitChanges());
    if (!action.error) {
      hide();
    }
  };

  const onValuesChange = (changedValues, allValues) => {
    const arr = getChangedItems(
      changedValues,
      allValues,
      changedItems,
      settings
    );
    dispatch(setChangedFormItems({ changed: arr, values: allValues }));
  };

  let { branchId } = useParams();
  const hasPermission = usePermission(branchId, "patients", "editor");
  return (
    <Layout>
      <SettingsWrapper>
        <SettingsHeader hide={hide} />
        <RestrictedContext.Provider
          value={{ hasWritePermission: hasPermission }}
        >
          <Form
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
            onValuesChange={onValuesChange}
            form={form}
            className="formBody"
          >
            <SettingsForm changedValues={changedValues} />
            <Spacer vertical={true} extra={true} />
            <FloatingFormActions
              resource={"patients"}
              action={"editor"}
              hideDelete={true}
              hideDecline={true}
              saveLoading={saveLoading}
              saveText={intl.formatMessage({
                id: "app.actions.saveChanges",
              })}
              show={changedItems.length > 0}
            />
          </Form>
        </RestrictedContext.Provider>
      </SettingsWrapper>
    </Layout>
  );
};

export default Settings;
